/* global System */
// register component(s) with react habitat

export default { ImageGrid: () => System.import('./Component') }
